import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const Close = ({ color, size, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '24px'}
      height={size || '24px'}
      color={color || 'currentColor'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.9996 12.7067L18.2961 19L19.0032 18.2932L12.7067 12L19.0032 5.70675L18.2961 5L11.9996 11.2932L5.7032 5L4.99609 5.70675L11.2925 12L4.99609 18.2932L5.7032 19L11.9996 12.7067Z"
        fill={color || 'currentColor'}
      />
    </StyledSvg>
  );
};
